/** Mermaid diagrams for Supabase edge functions. */

export const EDGE_FUNCTIONS_OVERVIEW_CHART = `
flowchart TB
  subgraph admin["Admin app browser"]
    UI["React · supabase.functions.invoke"]
  end

  subgraph jwt["JWT verified at gateway"]
    MAT["materialize-newsletter"]
    PREV["preview-newsletter"]
    SEND["request-send-scheduled-email"]
    PM_TPL["postmark-templates"]
    CAL["calendly-meetings"]
  end

  subgraph authInFn["Auth inside function"]
    TR["transcript-prompt"]
    IDX_T["index-transcript-chunks"]
    IDX_C["index-connection-embeddings"]
    SEM["search-connections-semantic"]
    INV["newsletter-invite-suggest"]
  end

  subgraph webhooks["Inbound webhooks secret in URL"]
    PM_WH["postmark-webhook"]
    INGEST["subscriber-custom-fields-ingest"]
  end

  subgraph worker["Background worker entry"]
    ING["inngest"]
  end

  UI --> jwt
  UI --> authInFn
  PM["Postmark"] --> PM_WH
  ZAP["Zapier / external"] --> INGEST
  ING_CLOUD["Inngest Cloud"] --> ING
  MAT --> ING_CLOUD
  SEND --> ING_CLOUD
`;
